var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartMixedDownCircleDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58984 22.2617L6.68359 21.2422L8.66602 19.373L9.57227 20.3926L13.1406 24.1875V11.0469V9.6875H15.8594V11.0469V24.1875L19.3711 20.3926L20.2773 19.373L22.2598 21.2422L21.3535 22.2617L15.4629 28.6055L14.5 29.625L13.4805 28.6055L7.58984 22.2617ZM14.5 3.34375C7.98633 3.34375 2.71875 8.61133 2.71875 15.125H0C0 7.13867 6.45703 0.625 14.5 0.625C22.4863 0.625 29 7.13867 29 15.125V16.4844H26.2812V15.125C26.2812 8.61133 20.957 3.34375 14.5 3.34375Z",
    fill: "#2BAD70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartMixedDownCircleDollar);
export default __webpack_public_path__ + "static/media/chart-mixed-down-circle-dollar.d43b78703af7d9e32c6173ad555b86d7.svg";
export { ForwardRef as ReactComponent };